<template>
  <div class="container mt-2 position-relative">
    <div class="d-flex align-items-center w-100 gap-2">
      <div class="select-wrapper w-100" style="max-width: 100px;">
        <select v-model="nivelSector" class="form-select w-100 fs-8 borde-terciario sombra-sm texto-principal" style="max-width: 100px; height: 40px;" @change="localStorage.setItem('filter_nivelSectorAusenciaSuplencia', nivelSector); seleccionarPrimeraPersonaPorSector()">
          <option value="Todos">{{ $t('todos') }}</option>
          <option value="ES">ES</option>
          <option value="EP">EP</option>
          <option value="KG">KG</option>
        </select>
        <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
        </svg>
      </div>

      <div class="d-flex align-items-center position-relative w-100 gap-2">
        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" class="position-absolute top-50 start-0 translate-middle-y ms-2" style="pointer-events: none">
          <path d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        
        <input
          id="buscadorPersona"
          type="text"
          class="form-control m-0 rounded-3 borde-terciario fondo-terciario sombra-sm"
          :placeholder="t('buscarDocentePorNombre') + '...'"
          v-model="searchQuery"
          style="padding-left: 35px; height: 40px;"
          @focus="isDropdownOpen = true"
          @blur="cerrarDropdown"
        />
        
        <button
          v-if="searchQuery"
          type="button"
          class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
          @click="limpiarSeleccion" 
        >
          <i class="bi bi-x texto-secundario" style="font-size: 30px;"></i>
        </button>
        
        <ul
          v-if="isDropdownOpen && personasFiltradas.length > 0"
          class="dropdown-menu show w-100 sombra-sm mt-2 border-0 fondo-terciario p-0"
          style="max-height: 250px; overflow-y: auto; position: absolute; top: 100%; left: 0; z-index: 1050;"
        >
          <li v-for="persona in personasFiltradas" :key="persona.IdPersona">
            <button
              class="dropdown-item py-2 border-bottom texto-principal fondo-terciario"
              @click.prevent="seleccionarPersona(persona)"
            >
              {{ persona.Apellido }}, {{ persona.Nombre }}
              <span class="badge fondo-terciario sombra-sm texto-principal border ms-2">{{ $t('siglaUntis') + ': ' + persona.SiglaUntis }}</span>
              <span v-if="persona.NivelSector" class="badge fondo-terciario sombra-sm texto-principal border ms-2">{{ persona.NivelSector }}</span>
            </button>
          </li>
        </ul>
        
        <ul
          v-else-if="isDropdownOpen && searchQuery && personasFiltradas.length === 0"
          class="dropdown-menu show w-100 sombra mt-2"
          style="position: absolute; top: 100%; left: 0; z-index: 1050;"
        >
          <li><span class="dropdown-item texto-secundario">{{ t('noResultados') }}</span></li>
        </ul>
      </div>

      <button 
        v-if="hasManejarAusenciasSuplenciasPermission"
        class="btn btn-outline-success sombra d-flex align-items-center gap-2 text-nowrap" 
        data-bs-toggle="modal"
        data-bs-target="#modalExportarExcel"
      >
        <i class="bi bi-file-earmark-excel"></i>
        {{ $t('exportarExcel') }}
      </button>
    </div>

    <div class="modal fade" id="modalExportarExcel" tabindex="-1" aria-labelledby="modalExportarExcelLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content fondo-secundario borde-secundario w-100 d-flex flex-column gap-4">
          <div class="modal-header border-bottom-0 p-0">
            <h5 class="modal-title texto-principal" id="modalExportarExcelLabel">
              <i class="bi bi-file-earmark-excel text-success me-2"></i>{{ $t('exportarExcel') }}
            </h5>
            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="exportandoExcel"></button> -->
            <button type="button" class="btn p-0" data-bs-dismiss="modal" :disabled="exportandoExcel">
              <svg width="20" height="20" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
                  <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                  <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                </g>
              </svg>
            </button>
          </div>
          <div class="modal-content-body p-0">
            <p class="texto-secundario fs-7 mb-3">{{ $t('seleccionarPeriodoExportar') }} <strong>{{ nivelSector === 'Todos' ? 'General' : nivelSector }}</strong>:</p>
            
            <div class="form-group">
              <label class="form-label texto-principal fw-bold mb-2">{{ $t('periodo') }}:</label>
              <div class="select-wrapper w-100 home-list">
                <select v-model="periodoSeleccionado" class="form-select texto-secundario border-0 cursor-pointer w-100 fondo-terciario" :disabled="exportandoExcel">
                  <option v-for="(p, index) in periodosDisponibles" :key="index" :value="p">
                    {{ p.nombreLabel }} ({{ p.fechaDesde }} al {{ p.fechaHasta }})
                  </option>
                </select>
                <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 d-flex justify-content-end gap-2 p-0">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" :disabled="exportandoExcel">
              {{ $t('cancelar') }}
            </button>
            <button type="button" class="btn btn-success d-flex align-items-center gap-2" @click="descargarExcel" :disabled="exportandoExcel || !periodoSeleccionado">
              <span v-if="exportandoExcel" class="spinner-border spinner-border-sm"></span>
              {{ exportandoExcel ? $t('generando') + '...' : $t('descargar') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="@/assets/LOADING.gif" style="width: 60px;" alt="Cargando..." />
    </div>
    <div v-if="personaSeleccionada" class="mt-4">
      <div class="d-flex gap-2 align-items-center ms-1 mb-2">
        <button
          class="p-2 d-flex align-items-center justify-content-center rounded bg-goethe-accent-claro-2 border-0 sombra-sm"
          :disabled="!hasAnterior"
          @click="irAnterior"
          title="Empleado Anterior"
          style="background: none;"
        >
          <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
            <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button
          class="p-2 d-flex align-items-center justify-content-center rounded bg-goethe-accent-claro-2 border-0 sombra-sm"
          :disabled="!hasSiguiente"
          @click="irSiguiente"
          title="Siguiente Empleado"
          style="background: none;"
        >
          <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <router-link :to="`/personas/verDatosPersona?id=${personaSeleccionada.IdPersona}`" class="texto-principal text-decoration-none">
          <h4 class="m-0">{{ personaSeleccionada.Apellido }}, {{ personaSeleccionada.Nombre }}</h4>
        </router-link>
        <span class="badge fondo-terciario sombra-sm texto-principal border-0 ms-2">{{ $t('siglaUntis') + ': ' + personaSeleccionada.SiglaUntis }}</span>
        <span class="badge fondo-terciario sombra-sm texto-principal border-0 ms-2">{{ $t('sector') + ': ' + personaSeleccionada.NivelSector }}</span>
      </div>
      <div>
        <HorariosSection :persona="personaSeleccionada" :esPerfilPropio="false" :key="personaSeleccionada.IdPersona" class="mb-5" />
      </div>
      <div>
        <AusenciasSection :persona="personaSeleccionada" :esPerfilPropio="false" :key="personaSeleccionada.IdPersona" class="mb-5" />
      </div>
      <div>
        <SuplenciasSection :persona="personaSeleccionada" :esPerfilPropio="false" :key="personaSeleccionada.IdPersona" class="mb-5" />
      </div>
    </div>
    
    <div v-else-if="!loading" class="alert alert-info text-center mt-4">
      <i class="bi bi-person-lines-fill me-2"></i>
      {{ t('noSeEncontraronEmpleados') }}
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from 'vue-i18n';
import api from '@/services/api';
import AusenciasSection from '@/components/PersonasTabs/AusenciasSection.vue';
import HorariosSection from '@/components/PersonasTabs/HorariosSection.vue';
import SuplenciasSection from '@/components/PersonasTabs/SuplenciasSection.vue';

export default {
  name: 'AusenciasSuplenciasDocentesPage',
  components: {
    AusenciasSection,
    HorariosSection,
    SuplenciasSection
  },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const hasManejarAusenciasSuplenciasPermission = ref(false);
    
    const personas = ref([]);
    const personaSeleccionada = ref(null);
    const nivelSector = ref(localStorage.getItem('filter_nivelSectorAusenciaSuplencia') || 'Todos');
    const searchQuery = ref('');
    const isDropdownOpen = ref(false);
    const loading = ref(false);
    const exportandoExcel = ref(false);

    // NUEVO: Estados para manejar las opciones del modal
    const periodosDisponibles = ref([]);
    const periodoSeleccionado = ref(null);

    // NUEVO: Generar dinámicamente los periodos de quincena a quincena (Actual y 2 anteriores)
    const calcularPeriodosQuincenas = () => {
      const opciones = [];
      const hoy = new Date();
      let añoActual = hoy.getFullYear();
      let mesActual = hoy.getMonth(); // 0 = Enero, 11 = Diciembre

      const nombresMeses = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
      ];

      // Generar 3 iteraciones (0: actual, 1: anterior, 2: tras-anterior)
      for (let i = 0; i < 3; i++) {
        let mesDesdeIdx = mesActual - i;
        let añoDesde = añoActual;

        // Ajuste en caso de retroceder al año anterior (ej: Enero - 1 mes)
        if (mesDesdeIdx < 0) {
          mesDesdeIdx += 12;
          añoDesde -= 1;
        }

        let mesHastaIdx = mesDesdeIdx + 1;
        let añoHasta = añoDesde;
        if (mesHastaIdx > 11) {
          mesHastaIdx = 0;
          añoHasta += 1;
        }

        // Armamos las cadenas YYYY-MM-DD requeridas por el Endpoint
        const mmDesde = String(mesDesdeIdx + 1).padStart(2, '0');
        const mmHasta = String(mesHastaIdx + 1).padStart(2, '0');

        const fDesdeStr = `${añoDesde}-${mmDesde}-16`;
        const fHastaStr = `${añoHasta}-${mmHasta}-15`;
        const labelStr = `${nombresMeses[mesDesdeIdx]} - ${nombresMeses[mesHastaIdx]}`;

        opciones.push({
          nombreLabel: labelStr,
          fechaDesde: fDesdeStr,
          fechaHasta: fHastaStr
        });
      }

      periodosDisponibles.value = opciones;
      // Pre-seleccionar la opción actual por comodidad
      periodoSeleccionado.value = opciones[0];
    };

    // NUEVO: Consumo de la API pasando las fechas del período seleccionado
    const descargarExcel = async () => {
      if (!periodoSeleccionado.value) return;

      exportandoExcel.value = true;
      try {
        const parametros = {
          fechaDesde: periodoSeleccionado.value.fechaDesde,
          fechaHasta: periodoSeleccionado.value.fechaHasta,
        };

        if (nivelSector.value !== 'Todos') {
          parametros.nivel = nivelSector.value;
        }

        const response = await api.get('/api/suplencias/exportar-excel', {
          params: parametros,
          responseType: 'blob', // Convierte la respuesta en datos binarios limpios
        });

        // Crear enlace de descarga virtual
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        const nivelNombre = nivelSector.value !== 'Todos' ? nivelSector.value : 'General';
        const labelLimpio = periodoSeleccionado.value.nombreLabel.replace(/\s+/g, '');
        link.setAttribute('download', `Suplencias_${nivelNombre}_Periodo_${labelLimpio}.xlsx`);
        
        document.body.appendChild(link);
        link.click();
        
        // Limpiar el DOM y memoria
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        // Cerrar el modal programáticamente tras la descarga exitosa utilizando la API nativa de Bootstrap
        const modalElement = document.getElementById('modalExportarExcel');
        const modalInstance = window.bootstrap?.Modal?.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
      } catch (error) {
        console.error("Error al exportar el archivo Excel:", error);
      } finally {
        exportandoExcel.value = false;
      }
    };

    // --- Lógica original intacta ---
    const seleccionarPrimeraPersonaPorSector = () => {
      if (!personas.value || personas.value.length === 0) return null;
      
      personaSeleccionada.value = personas.value.find(p => {
        if (!p.NivelSector) return false;
        const sectoresDocente = p.NivelSector.split(',').map(s => s.trim());

        if (nivelSector.value === 'Todos') {
          return sectoresDocente.some(sector => ['ES', 'EP', 'KG'].includes(sector));
        } else {
          return sectoresDocente.includes(nivelSector.value);
        }
      }) || null;
    };

    const fetchPersonas = async () => {
      try {
        loading.value = true;
        const response = await api.get('/api/Persona/ByRole?role=Profesor');
        personas.value = response.data;
        seleccionarPrimeraPersonaPorSector();
        loading.value = false;
      } catch (error) {
        console.error("Error al cargar la lista de profesores:", error);
        loading.value = false;
      }
    };

    const checkAuth = async () => {
      if (user.value && user.value.personasPermisos) {
        var permisoAComprobar = 'ManejarAusenciasSuplencias'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) ||
            user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
            hasManejarAusenciasSuplenciasPermission.value = true;
        }
        if (!hasManejarAusenciasSuplenciasPermission.value) {
          await router.push('/');
        }
      }
    };

    const personasFiltradas = computed(() => {
      let filtradas = personas.value.filter(p => {
        if (!p.NivelSector) return false;
        const sectoresDocente = p.NivelSector.split(',').map(s => s.trim());
        if (nivelSector.value === 'Todos') {
          return sectoresDocente.some(sector => ['ES', 'EP', 'KG'].includes(sector));
        } else {
          return sectoresDocente.includes(nivelSector.value);
        }
      });

      if (searchQuery.value) {
        const query = searchQuery.value.toLowerCase();
        filtradas = filtradas.filter(p =>
          (p.Apellido && p.Apellido.toLowerCase().includes(query)) ||
          (p.Nombre && p.Nombre.toLowerCase().includes(query)) ||
          (p.SiglaUntis && p.SiglaUntis.toLowerCase().includes(query))
        );
      }
      return filtradas;
    });

    const seleccionarPersona = (persona) => {
      searchQuery.value = '';
      personaSeleccionada.value = persona;
      isDropdownOpen.value = false;
    };

    const limpiarSeleccion = () => {
      searchQuery.value = '';
      isDropdownOpen.value = true; 
      document.getElementById('buscadorPersona').focus();
    };

    const cerrarDropdown = () => {
      setTimeout(() => {
        isDropdownOpen.value = false;
        if (!personaSeleccionada.value) {
          searchQuery.value = '';
        }
      }, 400);
    };

    const currentIndex = computed(() => {
      if (!personaSeleccionada.value) return -1;
      return personas.value.findIndex(p => p.IdPersona === personaSeleccionada.value.IdPersona);
    });

    const hasAnterior = computed(() => currentIndex.value > 0);
    const hasSiguiente = computed(() => currentIndex.value !== -1 && currentIndex.value < personas.value.length - 1);

    const irAnterior = () => {
      if (hasAnterior.value) seleccionarPersona(personas.value[currentIndex.value - 1]);
    };
    const irSiguiente = () => {
      if (hasSiguiente.value) seleccionarPersona(personas.value[currentIndex.value + 1]);
    };

    const sectoresDisponibles = computed(() => {
      const sectores = personas.value
        .map(p => p.SectorNivel)
        .filter(sector => sector !== null && sector !== undefined && sector.trim() !== '');
      return [...new Set(sectores)].sort(); 
    });

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0];
      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload();
      }
      
      calcularPeriodosQuincenas(); // <- Genera el período actual y los 2 anteriores
      checkAuth();
      fetchPersonas();
    });

    return {
      checkAuth,
      t,
      hasManejarAusenciasSuplenciasPermission,
      personas,
      personaSeleccionada,
      searchQuery,
      isDropdownOpen,
      personasFiltradas,
      seleccionarPersona,
      limpiarSeleccion,
      cerrarDropdown,
      hasAnterior,
      hasSiguiente,
      irAnterior,
      irSiguiente,
      sectoresDisponibles,
      loading,
      exportandoExcel,
      nivelSector,
      localStorage,
      seleccionarPrimeraPersonaPorSector,
      // Retornos de la lógica nueva
      periodosDisponibles,
      periodoSeleccionado,
      descargarExcel
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}

.roles-column {
  width: 250px; 
}

/* Estilo estético rápido para las opciones de periodos */
.combo-periodos {
  height: 45px;
  font-size: 15px;
  border-radius: 6px;
}
</style>